export default "__VITE_ASSET__BVfQzd24__"